import { useState } from "react";
import { LegalDocumentLinks } from "@/features/legal/components/LegalDocumentLinks";
import { LegalDocumentModal } from "@/features/legal/components/LegalDocumentModal";
import { LEGAL_COMPLIANCE_COPY, PRIVACY_DOCUMENT_KEY } from "@/features/legal/config/legal.config";
import { usePublicLegalDocuments } from "@/features/legal/hooks/usePublicLegalDocuments";
import type { LegalDocument } from "@/features/legal/types/legalCompliance.type";

// Privacy and cookie notices must be reachable from the login page, before
// any account exists; the CGU themselves are accepted after login.
type LoginLegalDocumentsProps = { isHidden?: boolean };

export const LoginLegalDocuments = ({ isHidden = false }: LoginLegalDocumentsProps) => {
  const { data: publicDocuments = [] } = usePublicLegalDocuments();
  const [openDocument, setOpenDocument] = useState<LegalDocument | null>(null);
  // Already linked from the attestation sentence right above the form actions.
  const documents = publicDocuments.filter((document) => document.key !== PRIVACY_DOCUMENT_KEY);

  if (isHidden || documents.length === 0) return null;

  return (
    <nav aria-label={LEGAL_COMPLIANCE_COPY.LOGIN_DOCUMENTS_LABEL} className="border-t border-gray-200 pt-5 text-center dark:border-gray-700" data-testid="login-legal-documents">
      <LegalDocumentLinks
        documents={documents}
        onOpen={setOpenDocument}
        className="justify-center"
        linkClassName="text-xs text-gray-500 no-underline hover:text-primary hover:underline dark:text-gray-400"
      />
      <LegalDocumentModal document={openDocument} onClose={() => setOpenDocument(null)} />
    </nav>
  );
};

LoginLegalDocuments.displayName = "LoginLegalDocuments";
